exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-stats .number{display:inline-block;margin:0 auto;color:#fff;padding:5px;font-size:var(--size-12);background-color:var(--color--blue);border-radius:26.8px;min-width:26.8px;text-align:center}.section-stats .empty-dot{display:inline-block;margin:0 auto;height:var(--size-12);width:var(--size-12);border-radius:50%;background-color:#ebebeb}", ""]);

// exports
